export default function SubmittalCiqIcon({
  size = 12,
  className = "fill-black",
  opacity = "0.6"
}: {
  size?: number;
  className?: string;
  opacity?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="10.4 12.3 21.2 18.4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.6625 16.3566V13.295C14.6625 12.7313 15.1354 12.2744 15.7188 12.2744H22.4938L24.6064 14.3155H30.5064C31.0898 14.3155 31.5627 14.7724 31.5627 15.336V25.5414C31.5627 26.1051 31.0898 26.562 30.5064 26.562H27.3376V29.6236C27.3376 30.1872 26.8647 30.6441 26.2814 30.6441H11.4938C10.9104 30.6441 10.4375 30.1872 10.4375 29.6236V17.3771C10.4375 16.8135 10.9104 16.3566 11.4938 16.3566H14.6625ZM14.6625 18.3977H12.55V28.603H25.2251V26.562H14.6625V18.3977ZM16.7751 14.3155V24.5209H29.4501V16.3566H23.7314L21.6188 14.3155H16.7751Z"
        fill="current"
        fillOpacity={opacity}
      />
    </svg>
  );
}
